export function capitalizeFirstLetter(str: string): string {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}


export function stripBase64Prefix(base64: string): string {
    return base64.replace(/^data:image\/[a-zA-Z0-9+]+;base64,/, "");
}